import axiosInstance from "./api";

export const listWards = async ({ page = 1, limit = 10, q = "" } = {}) => {
  return axiosInstance.get("wards/getElms", {
    params: { page, limit, q },
  });
};

export const createWard = async ({ data }) => {
  return axiosInstance.post("wards/createElm", data);
};

export const updateWard = async ({ id, data }) => {
  return axiosInstance.put(`wards/updateElm/${id}`, data);
};

export const deleteWard = async ({ id }) => {
  return axiosInstance.delete(`wards/deleteElm/${id}`);
};

export const getWard = async () => {
  return axiosInstance.get(`wards/getElm`);
};

export const uploadWardImage = async (formData) => {
  return axiosInstance.post("wards/uploadImage", formData);
};

export const deleteFile = async (filePaths) => {
  return axiosInstance.delete("wards/deleteFile", { data: { filePaths } });
};
